import { Button, ButtonWithIcon, ComponentLoader } from '@clickcease/cc-client-components-lib'
import React, { ReactNode, CSSProperties } from 'react'

import {
  WrapperWithButtonsButtons,
  WrapperWithButtonsContainer,
  WrapperWithButtonsContent,
} from './WrapperWithButtons.styled'

export interface WrapperWithButtonsProps {
  children: ReactNode
  ghostButtonText: string
  onGhostButtonClick: () => void
  isGhostButtonDisabled?: boolean
  isGhostButtonLoading?: boolean
  primaryButtonText: string
  onPrimaryButtonClick: () => void
  isPrimaryButtonDisabled?: boolean
  isPrimaryButtonLoading?: boolean
  primaryButtonIcon?: ReactNode
  modalLoading?: boolean
  id?: string
  style?: CSSProperties
}

export const WrapperWithButtons = ({
  children,
  onGhostButtonClick,
  ghostButtonText,
  primaryButtonText,
  onPrimaryButtonClick,
  isPrimaryButtonDisabled,
  isGhostButtonDisabled,
  isGhostButtonLoading,
  isPrimaryButtonLoading,
  primaryButtonIcon,
  modalLoading,
  id,
  style,
}: WrapperWithButtonsProps) => {
  return (
    <WrapperWithButtonsContainer id={id} style={style}>
      {modalLoading && <ComponentLoader />}
      <WrapperWithButtonsContent>{children}</WrapperWithButtonsContent>
      <WrapperWithButtonsButtons>
        <Button
          variant="ghost"
          onClick={onGhostButtonClick}
          text={ghostButtonText}
          disabled={isGhostButtonDisabled}
          loading={isGhostButtonLoading}
        />
        <ButtonWithIcon
          onClick={onPrimaryButtonClick}
          text={primaryButtonText}
          disabled={isPrimaryButtonDisabled}
          iconLeft={primaryButtonIcon}
          loading={isPrimaryButtonLoading}
        />
      </WrapperWithButtonsButtons>
    </WrapperWithButtonsContainer>
  )
}
